import { motion } from "framer-motion";

const WHILE_IN_VIEW = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-80px" };
const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={WHILE_IN_VIEW}
      viewport={VIEWPORT}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
